// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"349":"email-editor","552":"chartjs"}[chunkId] || chunkId) + "-" + {"94":"39e495ac922432a1cebe","349":"25196fbbcbb38713200f","492":"9728d559104abeb8a0be","552":"c975d17053be02ca6843","818":"c03c9bf99a6d1a34a4e1"}[chunkId] + ".chunk.js";
};